import TextInput from '../fields/TextInput';
import EmailInput from '../fields/EmailInput';
import {useEventContext} from "../../contexts/EventContext";
import {SchoolSearch} from "../index";
import {useState} from "preact/hooks";
import {useCustomerContext} from "../../contexts/CustomerContext";
import SelectInput from "../fields/SelectInput";
import {nationalityList} from "../../utils/nationalities";
import startCase from "lodash/startCase";
import Moment from 'moment';

const AttendeeForm = ({ index }) => {
    const { canUserModifyDetails, attendeeValidationErrors, setAttendeeQty, upsertAttendee, removeAttendee, attendees, canHaveMultipleAttendees } = useEventContext();
    const { isMember } = useCustomerContext();
    let attendee = attendees[index];
    if (! attendee) {
        attendee = {
            id: index + 1,
            first_name: '',
            last_name: '',
            email: '',
            parent_guardian_email: '',
            school: {
                value: '',
                label: '',
            },
            gender: '',
        }
    }

    const nationalities = () => {
        return [
            {
                value: '',
                label: 'Select your nationality',
            },
            ...(nationalityList.map((nationality) => {
                return {
                    value: nationality,
                    label: startCase(nationality),
                }
            }))
        ];
    }

    return (
        <fieldset className="esc-ii-flex esc-ii-flex-col esc-ii-mt-5">
            <div className="esc-ii-flex esc-ii-items-center esc-ii-justify-between esc-ii-w-full esc-ii-mb-6">
                <h5 className="esc-ii-capitalize esc-ii-no-underline esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-base">{`Attendee${canHaveMultipleAttendees() ? ` #${index + 1}` : ``} Details`}</h5>
                <span className="esc-ii-h-px esc-ii-bg-charcoal/40 esc-ii-block esc-ii-flex-auto esc-ii-mx-3"></span>
                {
                    canHaveMultipleAttendees() && (
                        <button type="button" onClick={() => {
                            setAttendeeQty((prevState) => prevState - 1);
                            removeAttendee(index);
                        }}>
                            <span className="esc-ii-uppercase esc-ii-font-montserrat esc-ii-text-[10px] esc-ii-text-primary esc-ii-font-extrabold">Remove</span>
                        </button>
                    )
                }
            </div>

            <div className="esc-ii-flex esc-ii-flex-col esc-ii-space-y-5">
                <TextInput
                    name="first_name"
                    label="First Name"
                    placeholder={`First name`}
                    value={attendee.first_name}
                    required
                    canModifyDetails={canUserModifyDetails()}
                    validationError={attendeeValidationErrors[index] && attendeeValidationErrors[index].first_name}
                    onChange={(event) => upsertAttendee({...attendee, ...{first_name: event.target.value}})}
                />
                <TextInput
                    name="last_name"
                    label="Last Name"
                    placeholder={`Last name`}
                    value={attendee.last_name}
                    type="text"
                    required
                    canModifyDetails={canUserModifyDetails()}
                    validationError={attendeeValidationErrors[index] && attendeeValidationErrors[index].last_name}
                    onChange={(event) => upsertAttendee({...attendee, ...{last_name: event.target.value}})}
                />
                <EmailInput
                    name="email"
                    label="Email Address"
                    placeholder="Please enter the email address here"
                    value={attendee.email}
                    required
                    canModifyDetails={canUserModifyDetails()}
                    validationError={attendeeValidationErrors[index] && attendeeValidationErrors[index].email}
                    onChange={(event) => upsertAttendee({...attendee, ...{email: event.target.value}})}
                />
                <EmailInput
                    name="parent_guardian_email"
                    label="Parent / Guardian Email Address"
                    placeholder="Parent / guardian email address here"
                    required
                    value={attendee.parent_guardian_email}
                    canModifyDetails={canUserModifyDetails()}
                    validationError={attendeeValidationErrors[index] && attendeeValidationErrors[index].parent_guardian_email}
                    onChange={(event) => upsertAttendee({...attendee, ...{parent_guardian_email: event.target.value}})}
                />
                <SchoolSearch
                    school={attendee.school.value}
                    required
                    onChange={(event, { newValue }) => {
                        upsertAttendee({...attendee, ...{school: { value: newValue, label: newValue }}});
                    }}
                    canModifyDetails={canUserModifyDetails()}
                    validationError={attendeeValidationErrors[index] && attendeeValidationErrors[index].school}
                />
                <SelectInput
                    name="gender"
                    label="Gender"
                    options={[{
                        value: '',
                        label: 'Select your gender',
                    }, {
                        value: 'M',
                        label: 'Male',
                    }, {
                        value: 'F',
                        label: 'Female',
                    }, {
                        value: 'N/A',
                        label: 'I\'d rather not say',
                    }]}
                    required
                    value={attendee.gender}
                    canModifyDetails={canUserModifyDetails()}
                    validationError={attendeeValidationErrors[index] && attendeeValidationErrors[index].gender}
                    onChange={(event) => upsertAttendee({...attendee, ...{gender: event.target.value}})}
                />
                <SelectInput
                    name="nationality"
                    label="Nationality"
                    options={nationalities()}
                    value={attendee.nationality}
                    required
                    canModifyDetails={canUserModifyDetails()}
                    validationError={attendeeValidationErrors[index] && attendeeValidationErrors[index].nationality}
                    onChange={(event) => upsertAttendee({...attendee, ...{nationality: event.target.value}})}
                />
                <TextInput
                    name="dob"
                    label="Date of birth"
                    placeholder={`Date of borth`}
                    value={attendee.dob}
                    type="date"
                    max={Moment().format('YYYY-MM-DD')}
                    required
                    canModifyDetails={canUserModifyDetails()}
                    validationError={attendeeValidationErrors[index] && attendeeValidationErrors[index].dob}
                    onChange={(event) => upsertAttendee({...attendee, ...{dob: event.target.value}})}
                />
            </div>
        </fieldset>
    );
}

export default AttendeeForm;
